import {GET_OTHER_DOCUMENT_INFO_SUCCESS, TreatyActions} from '../actions/treaty.actions';
import {OtherDocument} from "../../models/treaty.models";

export interface ITreatyState {
 otherDocuments: OtherDocument[]
}

const initialState: ITreatyState = <ITreatyState>{
  otherDocuments : null
};

export function treatyReducer (state = initialState, action: TreatyActions ) {
  switch (action.type) {
    case GET_OTHER_DOCUMENT_INFO_SUCCESS:
      let data = action.payload;
      data = data.map(documentGroup => {
        return {...documentGroup, navigation: documentGroup.navigation.map(document => {
          return {...document, isActive: false};
        })
      };
      });
      return {...state, otherDocuments: data};
    default:
      return <ITreatyState>{
        ...state
      };
  }
}

